import React from 'react'
import { Link } from '@tanstack/react-router'
import { useSiteConfig } from '../context/SiteConfigContext'

const PANEL_IMAGE =
  'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1600&q=80'

interface CustomerAuthLayoutProps {
  title: string
  subtitle: string
  children: React.ReactNode
}

export const CustomerAuthLayout: React.FC<CustomerAuthLayoutProps> = ({
  title,
  subtitle,
  children,
}) => {
  const { config } = useSiteConfig()
  const panelSrc = config.hero_showcase_image.trim() || PANEL_IMAGE
  const initial = (config.brand_name || 'B').charAt(0)

  return (
    <div className="min-h-dvh bg-[var(--bg-main)] text-[var(--text-primary)]">
      <div className="grid min-h-dvh lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)]">
        <aside className="relative hidden lg:block">
          <img src={panelSrc} alt="" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 p-12">
            <p className="font-title text-3xl font-semibold tracking-wide text-white">
              {config.brand_name}
            </p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/75">
              {config.brand_tagline}
            </p>
          </div>
        </aside>

        <section className="flex min-h-dvh flex-col bg-[var(--bg-card)] px-6 py-8 sm:px-12 lg:px-16">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[var(--border-gold)] bg-[var(--bg-main)] font-title text-lg font-semibold text-[var(--gold-main)]">
                {initial}
              </span>
              <span className="font-title text-lg font-semibold tracking-wide uppercase">
                {config.brand_name}
              </span>
            </Link>
            <Link
              to="/"
              className="text-sm text-[var(--text-muted)] underline-offset-4 hover:text-[var(--text-primary)] hover:underline"
            >
              Continue shopping
            </Link>
          </div>

          <div className="mx-auto flex w-full max-w-[400px] flex-1 flex-col justify-center py-10">
            <h1 className="font-title text-[2rem] font-semibold leading-tight tracking-tight">{title}</h1>
            <p className="mt-2 text-sm leading-relaxed text-[var(--text-muted)]">{subtitle}</p>
            <div className="mt-8">{children}</div>
          </div>

          <p className="text-center text-[11px] text-[var(--text-faint)]">
            By continuing you agree to our store terms and privacy policy.
          </p>
        </section>
      </div>
    </div>
  )
}
